import { connect } from 'react-redux'
import actions from '../../../../../store/actions'
import Form from './Form'

const mapStateToProps = state => ({
  isFetchingUser: state.user.isFetchingUser
})

const mapDispatchToProps = dispatch => ({
  signIn: (email, password, isMarketplace, captchaToken) =>
    dispatch(actions.user.signIn(email, password, isMarketplace, captchaToken))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form)
